import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/home_header.jpg";
import SEO from "../designSystem/SEO";
import LightOutlinedButton from "../designSystem/buttons/LightOutlinedButton";
import LineLinkButton from "../designSystem/buttons/LineLinkButton";
import { ReactComponent as MortgageAdvice } from "../../assets/icons/mortgage_advice.svg";
import { ReactComponent as PensionAdvice } from "../../assets/icons/pension_advice.svg";
import { ReactComponent as InvestmentAdvice } from "../../assets/icons/investment_advice.svg";
import { ReactComponent as PersonalApproach } from "../../assets/icons/personal_approach.svg";
import AboutUsImage1 from "../../assets/images/about_image_001.jpg";
import AboutUsImage2 from "../../assets/images/about_image_002.jpg";
import { scrollToContact } from "../utils/navigation";


const AboutUsPage = () => {
  return (
    <div>
      <SEO
        title="About Matthew Monk"
        description="Meet Matthew Monk and learn about the clear, personal approach offered by Monk Financial Planning."
        path="/about-us"
      />
      <Hero
        //         title={`Financial Clarity
        // Direction & Confidence`}
        //         subtitle="Wealth Management Solutions"
        showOverlay={true}
        // backgroundImage={HeroBackground}
        titleAlign="center"
        subtitleAlign="center"
        pageTitle="About Us"
        title="About Monk financial planning"
        subtitle="Whether you're planning your first home, reviewing your pension or looking to make the most of your investments, the right financial advice can give you greater clarity and confidence. At Monk Financial Planning, we take the time to understand your circumstances, goals and plans for the future, providing straightforward, personal advice tailored to you."
        showButton={true}
        textAlign="center"
      ></Hero>

      <div className="background-container bg-primary-1 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-reverse row-ratio-47-63">
          <div className="column gap-l">
            <LineLinkButton children="About Us" />
            <h4 className="text-gray-3 uppercase">Meet Matthew</h4>
            <div className="column gap-m">
              <div className="content text-gray-3">
                I'm Matthew Monk, the adviser behind Monk Financial Planning.
              </div>
              <div className="content text-gray-3">
                I believe financial advice should be personal, straightforward
                and easy to understand. My role is to understand your
                circumstances, your goals and what you want to achieve before
                helping you consider your options.
              </div>
              <div className="content text-gray-3">
                From mortgages and pensions to investments and retirement
                planning, I provide advice designed around you rather than a
                one-size-fits-all approach. I work with clients across North
                Wales and beyond.
              </div>
            </div>
          </div>
          <img
            src={AboutUsImage1}
            alt="Matthew Monk, financial adviser"
            className="image-cover"
          />
        </div>
      </div>
      <div className="background-container bg-gray-3 ">
        <div className="content-container row align-stretch gap-xxxxl py-xxl px-xxxl row-ratio-47-63">
          <img
            src={AboutUsImage2}
            alt="Financial planning consultation with a client"
          />
          <div className="column gap-l">
            <LineLinkButton children="OUR SERVICES" />
            <h4 className="text-primary-1 uppercase">
              Good financial advice starts with listening.
            </h4>
            <div className="column gap-l">
              <div className="content text-primary-1">
                It’s about taking the time to understand your individual
                circumstances, your priorities, and what truly matters to you,
                rather than offering a one-size-fits-all solution.
              </div>
              <div className="content text-primary-1">
                I take the time to build a clear picture of where you are today,
                what you want to achieve in the future, and the goals you have
                for yourself and your family before discussing any options. By
                understanding your position in detail, I can ensure that any
                recommendations are tailored specifically to your needs.
              </div>
              <div className="content text-primary-1">
                Throughout the process, I aim to keep things straightforward and
                transparent, avoiding unnecessary jargon and focusing on what is
                most relevant to you. The aim is to give you clarity and
                confidence when making important financial decisions, so you
                feel informed, supported, and in control every step of the way.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-container bg-gray-1 ">
        <div className="content-container py-xxl px-xxxl column gap-l align-center">
          <LineLinkButton onClick={scrollToContact} children="Contact Us" />
          <h4 className=" text-gray-3 uppercase">Want to find out more?</h4>
          <div className="content text-gray-3">
            Whether you know exactly what you need or simply have a question,
            get in touch with Matthew to discuss your plans.
          </div>
          <SecondaryButton onClick={scrollToContact} text="MAKE AN ENQUIRY" />
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
